import * as React from 'react';
import { cn } from '@restworld/utils-common';
export interface ModalContentProps {
  /**
   * Custom Content Element
   */
  children: React.ReactNode;
  noPadding?: boolean;
}

export function ModalContent({ children, noPadding }: ModalContentProps) {
  return (
    <StyledModalContent noPadding={noPadding} className="modal-content">
      {children}
    </StyledModalContent>
  );
}

const StyledModalContent = ({ noPadding, className, ...props }: any) => (
  <div className={cn('w-full', 'py-0 px-6 md:py-0 md:px-8', noPadding ? 'p-0 md:p-0' : '', className)} {...props} />
);

export default ModalContent;
